import { ProjectStatusEnum } from './ProjectStatusEnum.enum';

import { BaseFilter } from 'src/app/sharedFeatures/models/base-filter.model';
export class ProjectLookupSearchModel extends BaseFilter {
  name!: string;
  description!: string;
  startDate!: Date;
  endDate!: Date;
  budget!: number;
  sectionId?: number | null;
  projectStatus!: ProjectStatusEnum;
  duration!: number;
  icon!: string;
}
